import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _slicedToArray from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _regeneratorRuntime from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/regenerator";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { binarySearch, isFalsyOrEmpty } from '../../../base/common/arrays.js';
import { Range } from '../../common/core/range.js';
import { BracketSelectionRangeProvider } from '../smartSelect/bracketSelections.js';
export var WordDistance = /*#__PURE__*/function () {
  function WordDistance() {
    _classCallCheck(this, WordDistance);
  }

  _createClass(WordDistance, null, [{
    key: "create",
    value: function create(service, editor) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var model, position, _yield$BracketSelecti, _yield$BracketSelecti2, ranges, wordRanges, wordUntilPos;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (editor.getOption(96
                /* suggest */
                ).localityBonus) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", WordDistance.None);

              case 2:
                if (editor.hasModel()) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return", WordDistance.None);

              case 4:
                model = editor.getModel();
                position = editor.getPosition();

                if (service.canComputeWordRanges(model.uri)) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt("return", WordDistance.None);

              case 8:
                _context.next = 10;
                return new BracketSelectionRangeProvider().provideSelectionRanges(model, [position]);

              case 10:
                _yield$BracketSelecti = _context.sent;
                _yield$BracketSelecti2 = _slicedToArray(_yield$BracketSelecti, 1);
                ranges = _yield$BracketSelecti2[0];

                if (!(ranges.length === 0)) {
                  _context.next = 15;
                  break;
                }

                return _context.abrupt("return", WordDistance.None);

              case 15:
                _context.next = 17;
                return service.computeWordRanges(model.uri, ranges[0].range);

              case 17:
                wordRanges = _context.sent;

                if (wordRanges) {
                  _context.next = 20;
                  break;
                }

                return _context.abrupt("return", WordDistance.None);

              case 20:
                // remove current word
                wordUntilPos = model.getWordUntilPosition(position);
                delete wordRanges[wordUntilPos.word];
                return _context.abrupt("return", new ( /*#__PURE__*/function (_WordDistance) {
                  _inherits(_class, _WordDistance);

                  var _super = _createSuper(_class);

                  function _class() {
                    _classCallCheck(this, _class);

                    return _super.apply(this, arguments);
                  }

                  _createClass(_class, [{
                    key: "distance",
                    value: function distance(anchor, suggestion) {
                      if (!position.equals(editor.getPosition())) {
                        return 0;
                      }

                      if (suggestion.kind === 17
                      /* Keyword */
                      ) {
                        return 2 << 20;
                      }

                      var word = typeof suggestion.label === 'string' ? suggestion.label : suggestion.label.name;
                      var wordLines = wordRanges[word];

                      if (isFalsyOrEmpty(wordLines)) {
                        return 2 << 20;
                      }

                      var idx = binarySearch(wordLines, Range.fromPositions(anchor), Range.compareRangesUsingStarts);
                      var bestWordRange = idx >= 0 ? wordLines[idx] : wordLines[Math.max(0, ~idx - 1)];
                      var blockDistance = ranges.length;

                      var _iterator = _createForOfIteratorHelper(ranges),
                          _step;

                      try {
                        for (_iterator.s(); !(_step = _iterator.n()).done;) {
                          var range = _step.value;

                          if (!Range.containsRange(range.range, bestWordRange)) {
                            break;
                          }

                          blockDistance -= 1;
                        }
                      } catch (err) {
                        _iterator.e(err);
                      } finally {
                        _iterator.f();
                      }

                      return blockDistance;
                    }
                  }]);

                  return _class;
                }(WordDistance))());

              case 23:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    }
  }]);

  return WordDistance;
}();
WordDistance.None = new ( /*#__PURE__*/function (_WordDistance2) {
  _inherits(_class2, _WordDistance2);

  var _super2 = _createSuper(_class2);

  function _class2() {
    _classCallCheck(this, _class2);

    return _super2.apply(this, arguments);
  }

  _createClass(_class2, [{
    key: "distance",
    value: function distance() {
      return 0;
    }
  }]);

  return _class2;
}(WordDistance))();